import React from 'react';
import { Grid } from '@material-ui/core';

import { MenuItem } from '@keaze/web/components/select/select.styles';
import { FacetOption } from '@keaze/web/common/interfaces';
import { Name, Count } from './menuItemSelect.styles';

type RenderMenuItemSelect = (option: FacetOption) => JSX.Element;

type GetOptionSelect = (text: string, count: number | null) => JSX.Element;

export const getOptionSelect: GetOptionSelect = (
  text: string,
  count: number | null
) => (
  <Grid container alignItems="center" justifyContent="space-between">
    <Name variant="body1" color="textPrimary">
      {text}
    </Name>
    <Count variant="body1" color="textPrimary">
      {count}
    </Count>
  </Grid>
);

export const renderMenuItemSelect: RenderMenuItemSelect = (option) => {
  const { count, value, text } = option;

  return (
    <MenuItem key={text} value={value} disabled={count === 0}>
      {getOptionSelect(text, count)}
    </MenuItem>
  );
};
